import { Seatingplan } from "../../models"
import { SeatingplanActions } from './seatingplan.actions';

export interface SeatingplanState {
	currentSeatingplan: Seatingplan,
	seatingplans: Seatingplan[],
	queryName: string
};

const initialState: SeatingplanState  = {
	currentSeatingplan: null,
	seatingplans: [],
	queryName: null
}

export const seatingplanReducer = (state = initialState, action): SeatingplanState => {
	switch (action.type) {
		case SeatingplanActions.SEATINGPLAN_LOADED: {
			return Object.assign({}, state,
				{
					currentSeatingplan: action.payload
				})
		}
		case SeatingplanActions.LOAD_SEATINGPLANS_SUCCESS: {
			return Object.assign({}, state,
				{
					seatingplans: action.payload
				})
		}
		case SeatingplanActions.FILTER_SEATINGPLANS: {
			return Object.assign({}, state,
				{
					queryName: action.payload
				})
		}

		default: return state;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/seatingplan-components/seatingplan.reducer.ts